

export const aboutData = {
    title: "Who I am",
    description1: "My name is Mohammad Mahbub. I'm a Front-End Developer (MERN Stack) based in Dhaka, Bangladesh.",
    description2: "During the evening to midnight, I work as a Control Operator at the Ministry Of Foreign Affairs (Riyadh, Saudi Arabia) and in the Late at Night & Morning, I Learn Advanced (MERN Stack) Development and utilize the time to build my own products. I spent my leisure hours How To build my position in  Programming Sector. Right now I'm also trying Learn React-Native ( Android & iOS ) Apps Development. I love to learn and I Need to Know More About The Programming Sector.",
    image: 2
}